import DelectoryResource from '../DelectoryResource';

class ShoppingCarts extends DelectoryResource {
  constructor(opts) {
    super(opts);

    this.cart = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/shopping_carts/cart'
    });

    this.checkout = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/shopping_carts/checkout'
    });

    this.setCouponCode = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/shopping_carts/set_coupon_code'
    });

    this.addItem = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/shopping_carts/add_item'
    });

    this.updateItem = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/shopping_carts/update_item'
    });

    this.removeItem = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/shopping_carts/remove_item'
    });

    this.setPaymentMethod = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/shopping_carts/set_payment_method'
    });

    this.setShippingMethod = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/shopping_carts/set_shipping_method'
    });

    this.setShippingAddress = DelectoryResource.createEndpoint({
      authRequired: true,
      path: '/market/shopping_carts/set_shipping_address'
    });
  }
}

export default ShoppingCarts;



// WEBPACK FOOTER //
// banquet/lib/DelectoryApi/lib/resources/ShoppingCarts.js